import { CLIENT_PORTAL_MODULE, ClientPortalModuleValue } from '../../types/portal';

export interface PortalSection {
  path: string;
  module: ClientPortalModuleValue;
  /** i18n key; translated at render time, not here. */
  label: string;
}

/**
 * The portal's navigation, in display order. Each entry is shown only when the
 * tenant has switched its module on - the same flags the API enforces.
 */
export const PORTAL_SECTIONS: PortalSection[] = [
  { path: 'report', module: CLIENT_PORTAL_MODULE.TECH_SUPPORT, label: 'Report a fault' },
  { path: 'jobs', module: CLIENT_PORTAL_MODULE.TECH_SUPPORT, label: 'Service jobs' },
  { path: 'counters', module: CLIENT_PORTAL_MODULE.COUNTER_READINGS, label: 'Counter readings' },
];
